import { createAxiosInstance } from '../utils/axios.js'
import { cartService } from './cart.js'

const api = createAxiosInstance()

export const authService = {
  async register (email, password, firstName, lastName, phoneNumber) {
    try {
      const response = await api.post('/api/auth/register', {
        email,
        password,
        first_name: firstName,
        last_name: lastName,
        phone_number: phoneNumber || null
      })

      if (response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user))
        cartService.mergeAndSync(response.data.user.id)
      }

      return { success: true, data: response.data }
    } catch (error) {
      if (
        error.message?.includes('ERR_BLOCKED_BY_CLIENT') ||
        error.code === 'ERR_BLOCKED_BY_CLIENT'
      ) {
        return {
          success: false,
          error:
            'Request blocked by browser extension. Please disable ad blockers or privacy extensions for this site and try again.'
        }
      }
      return {
        success: false,
        error:
          error.response?.data?.error || error.message || 'Registration failed'
      }
    }
  },

  async login (email, password) {
    try {
      const response = await api.post('/api/auth/login', {
        email,
        password
      })

      if (response.data.user) {
        localStorage.setItem('user', JSON.stringify(response.data.user))
        cartService.mergeAndSync(response.data.user.id)
      }

      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.error || error.message || 'Login failed'
      }
    }
  },

  async logout () {
    try {
      await api.post('/api/auth/logout')
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      localStorage.removeItem('user')
      cartService.setUserId(null)
      cartService.clearLocalCart()
    }
  },

  async getCurrentUser () {
    try {
      const response = await api.get('/api/auth/me')
      if (response.data) {
        localStorage.setItem('user', JSON.stringify(response.data))

        console.log('getCurrentUser success:', response.data)

        return response.data
      }
    } catch (error) {
      console.error('getCurrentUser error:', error)

      localStorage.removeItem('user')
      return null
    }
    return null
  },

  getStoredUser () {
    const userStr = localStorage.getItem('user')

    return userStr ? JSON.parse(userStr) : null
  },

  isAuthenticated () {
    return !!this.getStoredUser()
  },

  async forgotPassword (email) {
    try {
      const response = await api.post('/api/auth/forgot-password', {
        email
      })
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.error ||
          error.message ||
          'Failed to send password reset email'
      }
    }
  },

  async resetPassword (token, password) {
    try {
      const response = await api.post('/api/auth/reset-password', {
        token,
        password
      })
      return { success: true, data: response.data }
    } catch (error) {
      return {
        success: false,
        error:
          error.response?.data?.error ||
          error.message ||
          'Failed to reset password'
      }
    }
  }
}
